<template>
  <Teleport to="body">
    <div v-if="visible" class="register-dialog-pop" ref="dialog" @click.stop>
      <!-- 右上角关闭按钮 -->
      <button class="close-btn" @click="emit('close')" aria-label="关闭">&times;</button>
      <div class="dialog-content">
        <div class="tab-switch" v-if="showTabSwitch">
          <!-- 注册/登录tab -->
          <button :class="{ active: activeTab === 'register' }" @click="activeTab = 'register';">{{
            t('loginRegister.registerTab') }}</button>
          <button :class="{ active: activeTab === 'login' }" @click="activeTab = 'login'; refreshCaptcha()">{{
            t('loginRegister.loginTab') }}</button>
        </div>
        <template v-if="activeTab === 'register'">
          <!-- 注册表单 -->
          <h3>{{ t('loginRegister.registerTitle') }}</h3>
          <!-- 邮箱 -->
          <label class="label-common">
            {{ t('loginRegister.email') }}
            <span style="color:red;margin-left:2px;">*</span>
          </label>
          <input type="email" v-model="registerUsername" :placeholder="t('loginRegister.emailPlaceholder')"
            class="input-common" @input="validateEmail" />
          <div v-if="emailError" class="error-message">{{ t('loginRegister.emailFormatError') }}</div>

          <!-- 昵称 -->
          <label class="label-common">
            {{ t('loginRegister.nickname') }}
            <span style="color:red;margin-left:2px;">*</span>
          </label>
          <input type="text" v-model="registerNickName" :placeholder="t('loginRegister.nicknamePlaceholder')"
            class="input-common" />

          <!-- 手机号 -->
          <label class="label-common">
            {{ t('loginRegister.phone') }}
            <span style="color:red;margin-left:2px;">*</span>
          </label>
          <input type="tel" v-model="registerPhone" :placeholder="t('loginRegister.phonePlaceholder')"
            class="input-common" />

          <!-- 密码 -->
          <label class="label-common">
            {{ t('loginRegister.password') }}
            <span style="color:red;margin-left:2px;">*</span>
          </label>
          <input type="password" v-model="registerPassword" :placeholder="t('loginRegister.passwordPlaceholder')"
            class="input-common" />
          <div class="password-strength" v-if="registerPassword">
            <div :class="['meter', strengthLevelClass]">
              <span class="bar" :class="{ active: passwordActiveBars >= 1 }"></span>
              <span class="bar" :class="{ active: passwordActiveBars >= 2 }"></span>
              <span class="bar" :class="{ active: passwordActiveBars >= 3 }"></span>
            </div>
            <div class="strength-text" :class="strengthLevelClass">
              {{ tStrengthLabel }}
            </div>
          </div>
          <!-- 确认密码 -->
          <label class="label-common">
            {{ t('loginRegister.confirmPassword') }}
            <span style="color:red;margin-left:2px;">*</span>
            <span v-if="isPasswordMatch && registerConfirmPassword" class="password-match-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 6L9 17L4 12" stroke="#fb6e01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </label>
          <input type="password" v-model="registerConfirmPassword"
            :placeholder="t('loginRegister.confirmPasswordPlaceholder')" class="input-common" />
          <!-- 图片验证码 -->
          <label class="label-common">
            {{ t('loginRegister.captcha') }}
            <span style="color:red;margin-left:2px;">*</span>
          </label>
          <div class="captcha-row">
            <input type="text" v-model="registerCaptcha" :placeholder="t('loginRegister.captchaPlaceholder')"
              class="input-common captcha-input" />
            <!-- <img :src="captchaImg" @click="refreshCaptcha" class="captcha-img"
              :title="t('loginRegister.refreshCaptcha')" /> -->
            <button @click="handleSendCaptchaClick(registerUsername)" :disabled="sendBtnCountdown > 0" class="captcha-send-btn">{{ sendBtnCountdown > 0 ? (sendBtnCountdown + 's') : t('loginRegister.sendCaptcha') }}</button>
          </div>
          <!-- 邀请码 -->
          <label class="label-common">
            {{ t('loginRegister.inviteCode') }}
            <!-- <span style="color:red;margin-left:2px;">*</span> -->
          </label>
          <input type="text" v-model="registerInviteCode" :placeholder="t('loginRegister.inviteCodePlaceholder')"
            class="input-common" />
          <button class="btn-Login" style="width:100%;margin-bottom:10px;" @click="handleRegister">
            {{ t('loginRegister.register') }}
          </button>
          <div style="text-align:center; font-size:14px; margin-top:8px;">
            {{ t('loginRegister.hasAccount') }}
            <span style="color:#fb6e01;text-decoration:underline;cursor:pointer;" @click.prevent="switchToLogin">{{
              t('loginRegister.goLogin') }}</span>
          </div>
        </template>
        <template v-else>
          <!-- 登录表单 -->
          <h3>{{ t('loginRegister.loginTitle') }}</h3>
          <label class="label-common">
            {{ t('loginRegister.email') }}
            <span style="color:red;margin-left:2px;">*</span>
          </label>
          <input type="text" :placeholder="t('loginRegister.emailPlaceholder')" class="input-common"
            v-model="loginUsername" autocomplete="username" />
          <label class="label-common">
            {{ t('loginRegister.password') }}
            <span style="color:red;margin-left:2px;">*</span>
          </label>
          <input type="password" :placeholder="t('loginRegister.passwordPlaceholder')" class="input-common"
            v-model="loginPassword" autocomplete="current-password" />
          <label class="label-common" style="margin-top: 8px;">
            {{ t('loginRegister.captcha') }}
            <span style="color:red;margin-left:2px;">*</span>
          </label>
          <div class="captcha-row">
            <input type="text" :placeholder="t('loginRegister.captchaPlaceholder')" class="input-common captcha-input"
              v-model="loginCaptcha" autocomplete="off" />
            <img :src="captchaImg" @click="refreshCaptcha" class="captcha-img"
              :title="t('loginRegister.refreshCaptcha')" />
          </div>
          <div class="remember-row">
            <label style="display: flex; align-items: center; font-size: 14px;">
              <input type="checkbox" style="margin-right: 4px;" /> {{ t('loginRegister.rememberMe') }}
            </label>
            <a href="#" style="font-size: 14px; color: #fb6e01; text-decoration: underline;"
              @click.prevent="goToForgetPassword">{{ t('loginRegister.forgotPassword') }}</a>
          </div>
          <button class="btn-Login" style="width:100%;margin-bottom:10px;" @click="handleLogin"
            :disabled="loginLoading">
            <span v-if="loginLoading">{{ t('loginRegister.loggingIn') || '登录中...' }}</span>
            <span v-else>{{ t('loginRegister.login') }}</span>
          </button>
          <div style="text-align:center; font-size:14px; margin-top:8px;border-top: 1px solid #cccccc;">
            <div class="register-googleBtn" @click="handleGoogleAuth">
                <span>{{t('loginRegister.googleRegister')}}</span>
            </div>
            <div class="register-googleBtn" @click="handleAppleAuth">
                <span>{{t('loginRegister.appleRegister')}}</span>
            </div>
            {{ t('loginRegister.newToTigu') }}
            <span style="color:#fb6e01;text-decoration:underline;cursor:pointer;" @click.prevent="switchToRegister">{{
              t('loginRegister.createAccount') }}</span>
          </div>
        </template>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, watch, onBeforeUnmount, computed } from 'vue'


import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import { getUserInfo, login, getCaptcha, register, apiSendCaptcha } from '@/api/userLogin'
import { ElMessage, ElLoading } from 'element-plus'
import { setToken } from '@/services/auth'
import { Capacitor } from '@capacitor/core'
import axios from 'axios'
import { nativeGoogleSignIn } from '@/plugins/googleAuth'

const { t } = useI18n()

const props = defineProps<{
  visible: boolean
  target?: HTMLElement | null
}>()

const emit = defineEmits(['close', 'login-success'])

const dialog = ref<HTMLElement | null>(null)

const activeTab = ref<'login' | 'register'>('login')
const showTabSwitch = ref(false)
const centered = ref(false)
const router = useRouter()

// 新增：登录表单数据
const loginUsername = ref('')
const loginPassword = ref('')
const loginCaptcha = ref('')
const loginLoading = ref(false)
const captchaImg = ref('')
const captchaUuid = ref('')

// 注册表单数据
const registerUsername = ref('');
const registerPassword = ref('');
const registerConfirmPassword = ref('');
const registerInviteCode = ref('');
const registerPhone = ref('');
const registerCaptcha = ref('');
const registerNickName = ref('');

// 邮箱格式验证
const validateEmailFormat = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

// 邮箱验证状态
const emailError = ref(false);

// 实时邮箱验证
const validateEmail = () => {
  emailError.value = !validateEmailFormat(registerUsername.value);
};

// 密码强度（弱/中/强）
const passwordStrength = computed(() => {
  const pwd = registerPassword.value || '';
  let score = 0;
  const hasLower = /[a-z]/.test(pwd);
  const hasUpper = /[A-Z]/.test(pwd);
  const hasNumber = /\d/.test(pwd);
  const hasSpecial = /[^A-Za-z0-9]/.test(pwd);
  const variety = [hasLower, hasUpper, hasNumber, hasSpecial].filter(Boolean).length;
  if (pwd.length >= 8) score += 1; // 基础长度
  if (variety >= 2) score += 1;    // 至少两类字符
  if (pwd.length >= 10 && variety >= 3) score += 1; // 更强要求
  return score; // 0..3
});

const passwordStrengthLevel = computed<'empty' | 'weak' | 'medium' | 'strong'>(() => {
  const pwd = registerPassword.value || '';
  if (!pwd) return 'empty';
  const s = passwordStrength.value;
  if (s <= 1) return 'weak';
  if (s === 2) return 'medium';
  return 'strong';
});

const passwordActiveBars = computed<number>(() => {
  switch (passwordStrengthLevel.value) {
    case 'weak': return 1;
    case 'medium': return 2;
    case 'strong': return 3;
    default: return 0;
  }
});

const strengthLevelClass = computed<string>(() => `level-${passwordStrengthLevel.value}`);

const tStrengthLabel = computed<string>(() => {
  switch (passwordStrengthLevel.value) {
    case 'weak':
      return (t('loginRegister.weak') as string) || '弱';
    case 'medium':
      return (t('loginRegister.medium') as string) || '中';
    case 'strong':
      return (t('loginRegister.strong') as string) || '高';
    default:
      return '';
  }
});

const isPasswordMediumOrAbove = computed<boolean>(() => ['medium', 'strong'].includes(passwordStrengthLevel.value));

// 获取验证码
async function fetchCaptcha() {
  try {
    const response = await getCaptcha()
    // 假设后端返回 { img: 'data:image/png;base64,...', uuid: 'xxxx' }
    captchaImg.value = 'data:image/png;base64,' + response.data.img
    captchaUuid.value = response.data.uuid
  } catch (error) {
    console.error('获取验证码失败:', error)
    ElMessage.error({
      message: t('loginRegister.getCaptchaFailed'),
      duration: 2000
    })
  }
}
function refreshCaptcha() {
  fetchCaptcha()
}

//发送验证码（注册）60s 倒计时
const sendBtnCountdown = ref(0)
let sendBtnTimer: number | null = null

function startSendBtnCountdown(seconds = 60) {
  sendBtnCountdown.value = seconds
  if (sendBtnTimer) {
    window.clearInterval(sendBtnTimer)
  }
  sendBtnTimer = window.setInterval(() => {
    sendBtnCountdown.value -= 1
    if (sendBtnCountdown.value <= 0) {
      if (sendBtnTimer) {
        window.clearInterval(sendBtnTimer)
        sendBtnTimer = null
      }
    }
  }, 1000)
}

async function handleSendCaptchaClick(email: string) {
  if (sendBtnCountdown.value > 0) return
  if (!email || !validateEmailFormat(email)) {
    ElMessage.warning({
      message: t('loginRegister.emailFormatError'),
      duration: 2000
    })
    return
  }
  try {
    const response: any = await apiSendCaptcha({ email })
    if (response?.code === 200 || response?.captchaEnabled === true) {
      ElMessage.success({
        message: t('loginRegister.sendCaptchaSuccess'),
        duration: 2000
      })
      captchaUuid.value = response.uuid
      startSendBtnCountdown(60)
    } else {
      throw new Error(response?.msg || 'send failed')
    }
  } catch (error) {
    ElMessage.error({
      message: t('loginRegister.getCaptchaFailed'),
      duration: 2000
    })
  }
}

// 切换到注册并显示tab切换按钮，并让弹窗居中
function switchToRegister() {
  activeTab.value = 'register'
  showTabSwitch.value = true
  centered.value = true
  // refreshCaptcha()
}

// 切换到登录并显示tab切换按钮，弹窗依然居中
function switchToLogin() {
  refreshCaptcha()
  // 清空注册表单内容
  registerUsername.value = '';
  registerPassword.value = '';
  registerConfirmPassword.value = '';
  registerInviteCode.value = '';
  registerPhone.value = '';
  registerCaptcha.value = '';
  registerNickName.value = '';
  emailError.value = false;

  activeTab.value = 'login'
  showTabSwitch.value = true
  centered.value = true
}

// 点击弹窗外部关闭
function handleClickOutside(e: MouseEvent) {
  if (dialog.value && !dialog.value.contains(e.target as Node)) {
    emit('close')
  }
}

watch(
  () => props.visible,
  (val) => {
    if (val) {
      activeTab.value = 'login'
      showTabSwitch.value = false
      centered.value = false
      document.addEventListener('mousedown', handleClickOutside)
      refreshCaptcha() // 显示验证码
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }
)

watch(
  () => props.target,
  () => {
  }
)

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', handleClickOutside)
  if (sendBtnTimer) {
    window.clearInterval(sendBtnTimer)
    sendBtnTimer = null
  }
})

function goToForgetPassword() {
  emit('close')
  router.push({ name: 'ForgetPassword' })
}

// 登录请求
const handleLogin = async () => {
  if (!loginUsername.value || !loginPassword.value || !loginCaptcha.value) {
    ElMessage.warning({
      message: t('loginRegister.registerRequired'),

      duration: 2000
    })
    return
  }
  loginLoading.value = true

  const loadingInstance = ElLoading.service({
    lock: true,
    text: t('loginRegister.loginLoading') || '登录中...',
    background: 'rgba(255,255,255,0.7)'
  })

  const params = {
    username: loginUsername.value,
    password: loginPassword.value,
    code: loginCaptcha.value, // 添加验证码字段
    uuid: captchaUuid.value
  }
  try {

  login(params).then((response: any) => {
      loadingInstance.close()

      if (response.code !== 200) {
        ElMessage.error({
          message: t('loginRegister.loginFailed'),
          duration: 2000 // 2秒后自动消失，单位毫秒
        })
        refreshCaptcha()
        return
      }

      // 假设后端返回 token
      if (response.data) {

        ElMessage.success({
          message: t('loginRegister.loginSuccess'),
          duration: 2000 // 2秒后自动消失，单位毫秒
        })

        // 清空登录表单内容
        // loginUsername.value = '';
        // loginPassword.value = '';
        // loginCaptcha.value = '';

  localStorage.setItem('token', response.data.token)
  setToken(response.data.token)

        // 获取用户信息

        getUserInfo().then((userResponse) => {
          userResponse.data.username = loginUsername.value // 确保用户名正确
          localStorage.setItem('userInfo', JSON.stringify(userResponse.data))

          const userInfo = {
            userId: userResponse.data.user.userId,
            username: loginUsername.value,
            password: loginPassword.value,
            nickname: userResponse.data.user.nickName,
            email: userResponse.data.user.email,
            phonenumber: userResponse.data.user.phonenumber,
            userType: userResponse.data.user.userType,
          }
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
          window.location.reload();
        }).catch((error) => {
          console.error('获取用户信息失败:', error)
          ElMessage.error({
            message: t('loginRegister.getUserInfoFailed'),
            duration: 2000 // 2秒后自动消失，单位毫秒
          })
        })
        emit('login-success')
        emit('close')
        //router.push('/myaccount')
      } else {
        ElMessage.warning({
          message: t('loginRegister.loginFailed'),
          duration: 2000 // 2秒后自动消失，单位毫秒
        })
      }
    })
  } catch (e: any) {
    loadingInstance.close()
    refreshCaptcha()
    ElMessage.error({
      message: t('loginRegister.loginFailed'),
      duration: 2000 // 2秒后自动消失，单位毫秒
    })
  } finally {
    loginLoading.value = false
  }
}
// 密码是否匹配
const isPasswordMatch = computed(() => {
  return registerPassword.value === registerConfirmPassword.value && registerConfirmPassword.value !== '';
});
// 注册请求
const handleRegister = async () => {
  // 验证邮箱格式
  if (!validateEmailFormat(registerUsername.value)) {
    ElMessage.warning({
      message: t('loginRegister.emailFormatError'),
      duration: 2000
    });
    return;
  }

  if (!registerUsername.value || !registerPassword.value || !registerConfirmPassword.value || !registerPhone.value || !registerCaptcha.value || !registerNickName.value) {
    ElMessage.warning({
      message: t('loginRegister.registerRequired'),
      duration: 2000
    });
    return;
  }

  // 校验密码强度（至少中）
  if (!isPasswordMediumOrAbove.value) {
    ElMessage.warning({
      message: (t('loginRegister.passwordTooWeak') as string) || '密码强度过低，请使用至少8位且包含两种不同字符类型的密码',
      duration: 2000
    });
    return;
  }

  // 验证密码和确认密码是否一致
  if (registerPassword.value !== registerConfirmPassword.value) {
    ElMessage.warning({
      message: t('loginRegister.passwordMismatch'),
      duration: 2000
    });
    return;
  }

  const loadingInstance = ElLoading.service({
    lock: true,
    text: "",
    background: 'rgba(255,255,255,0.7)'
  });

  const params = {
    username: registerUsername.value,
    password: registerPassword.value,
    phone: registerPhone.value,
    inviteCode: registerInviteCode.value,
    code: registerCaptcha.value,
    uuid: captchaUuid.value,
    nickName: registerNickName.value
  };


  try {
  const response: any = await register(params);

    loadingInstance.close();

    if (response.code !== 200) {
      ElMessage.error({
        message: t('loginRegister.registerFailed'),
        duration: 2000
      });
      // refreshCaptcha();
      return;
    }

    ElMessage.success({
      message: t('loginRegister.registerSuccess'),
      duration: 2000
    });
  localStorage.setItem('token', response.data.token)
    setToken(response.data.token)

        // 获取用户信息
        getUserInfo().then((userResponse) => {
          userResponse.data.username = registerUsername.value // 确保用户名正确
          localStorage.setItem('userInfo', JSON.stringify(userResponse.data))

          const userInfo = {
            userId: userResponse.data.user.userId,
            username: registerUsername.value,
            password: registerPassword.value,
            nickname: userResponse.data.user.nickName,
            email: userResponse.data.user.email,
            phonenumber: userResponse.data.user.phonenumber,
            userType: userResponse.data.user.userType,
          }
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
          window.location.reload();
        }).catch((error) => {
          console.error('获取用户信息失败:', error)
          ElMessage.error({
            message: t('loginRegister.getUserInfoFailed'),
            duration: 2000 // 2秒后自动消失，单位毫秒
          })
        })
        emit('login-success')
        emit('close')
    // switchToLogin();

  } catch (error) {
    loadingInstance.close();
    console.error('注册失败:', error);
    ElMessage.error({
      message: t('loginRegister.registerFailed'),
      duration: 2000
    });
    // refreshCaptcha();
  }
};
// ===================== 第三方登录（原生优先，Web 回退） =====================
async function handleGoogleAuth() {
  const isNative = Capacitor.getPlatform() === 'android'
  const API_BASE = (import.meta as any).env.VITE_API_BASE || 'https://api.wetigu.com'
  if (!isNative) {
    window.location.href = `${API_BASE}/api/auth/google/render`
    return
  }
  try {
    
  const { idToken } = await nativeGoogleSignIn()
    if (!idToken) {
      ElMessage.warning({ message: '未获取到 Google 登录令牌（可能是 Play 服务网络受限或 OAuth 客户端配置不匹配）', duration: 3000 })
      return
    }
    ElMessage.success({ message: '已获取 Google 登录令牌', duration: 1500 })
  // exchange token with backend

  const resp = await axios.post(`${API_BASE}/api/auth/google/native-login`, { idToken })
    if (resp?.data?.code !== 200 || !resp?.data?.data?.token) {
      const msg = resp?.data?.msg || '原生Google登录失败'
      ElMessage.error({ message: msg, duration: 2500 })
  // backend returned non-success
      return
    }
    const bizToken = resp.data.data.token
    localStorage.setItem('token', bizToken)
    setToken(bizToken)
    try {
      const userResponse = await getUserInfo()
      localStorage.setItem('userInfo', JSON.stringify(userResponse.data))
    } catch (e) {
      // ignore user info failure
    }
    ElMessage.success({ message: t('loginRegister.loginSuccess'), duration: 2000 })
    emit('login-success')
    emit('close')
    window.location.reload()
  } catch (err) {
    try {
      const rawMsg = (err as any)?.message || (typeof err === 'string' ? err : '') || ''
      // 将常见的模糊报错翻译为可行动建议
      const mapped = /Something went wrong/i.test(rawMsg)
        ? 'Google 返回通用错误：常见于设备上 Google Play 服务无法连通（需要可访问 Google 的网络）或 OAuth Client 配置不匹配（请确认使用 Web Client ID 且包名与 SHA-1 一致）。'
        : rawMsg
      const errMsg = mapped || '原生 Google 登录失败'
      ElMessage.error({ message: errMsg, duration: 5000 })
    } catch (_) {}
  }
}

// Apple 登录：暂保持浏览器跳转（亦可后续接入 Capacitor 插件）
const handleAppleAuth = async () => {
  window.location.href = 'https://api.wetigu.com/api/auth/apple/render'
}

</script>

<style scoped>
.register-dialog-pop {
  background: #fff;
  padding: 24px 16px 16px 16px;
  border-radius: 8px;
  min-width: 0;
  max-width: 450px;
  width: 100%;
  max-height: 80vh;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
  border: 1px solid #eee;
  box-sizing: border-box;
  position: fixed;
  top: 90px;
  right: 20px;
  z-index: 9;
}

@media screen and (max-width: 600px) {
  .register-dialog-pop {
    width: 90%;
    left: 5%;
    top: 5%;
  }
}

.dialog-content {
  overflow-y: auto;
  max-height: calc(80vh - 24px);
  /* 让内容滚动，X始终固定 */
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 34px;
  color: #888;
  cursor: pointer;
  z-index: 10;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #fb6e01;
}

.tab-switch {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.tab-switch button {
  flex: 1;
  padding: 8px 0;
  border: none;
  background: none;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  color: #888;
  border-bottom: 2px solid transparent;
  transition: color 0.2s, border-bottom 0.2s;
}

.tab-switch button.active {
  color: #fb6e01;
  border-bottom: 2px solid #fb6e01;
}

.btn-Login {
  flex: 2;
  background-color: #fb6e01;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 15px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background-color: #e05602;
  }
}
/* 密码是否一致 */
.password-confirm-container {
  position: relative;
  margin-bottom: 16px;
}

.password-match-icon {
  position: absolute;
  right: 0;
  top: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #fb6e01;
  border-radius: 50%;
  width: 24px;
  height: 24px;
}
/* 右上角关闭按钮样式 */
.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 34px;
  color: #888;
  cursor: pointer;
  z-index: 10;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #fb6e01;
}

.remember-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  width: 100%;
  gap: 10px;
  flex-wrap: nowrap;
  min-width: 0;
}

.remember-row label,
.remember-row a {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

/* 统一label样式 */
.label-common {
  font-size: 14px;
  margin-bottom: 4px;
  display: block;
  margin-left: 2px;
  font-weight: 500;
  color: #222;
  letter-spacing: 0.5px;
  margin-left: 10px;
  position: relative;
}

/* 你可以保留 input 的统一样式 */
.input-common {
  width: 95%;
  padding: 8px;
  font-size: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
  outline: none;
  box-sizing: border-box;
  margin-bottom: 10px;
  margin-left: 2px;
  margin-right: 2px;
  transition: border 0.2s, box-shadow 0.2s;
  background: #fafafa;
}
.register-googleBtn {
  width: 100%;
  padding: 6px 0;
  margin: 10px 0;
  font-size: 14px;
  text-align: center;
  border: 1px solid #c8c8c8;
  border-radius: 28px;
  /* background: radial-gradient(circle at center, #ff8e37, #fb6e01); */
  /* box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1); */
  color: #434343;
  cursor: pointer;
}
.input-common:focus {
  border-color: #fb6e01;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(249, 99, 2, 0.08);
}

/* 验证码相关样式 */
.captcha-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.captcha-input {
  flex: 0 0 120px;
  max-width: 120px;
  min-width: 80px;
  margin-bottom: 0;
}

.captcha-img {
  height: 36px;
  width: 130px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #eee;
  display: block;
}

.error-message {
  color: red;
  font-size: 12px;
  margin-left: 5px;
}

/* 密码强度样式 */
.password-strength {
  width: 95%;
  margin-left: 2px;
  margin-right: 2px;
  margin-top: -6px;
  margin-bottom: 10px;
}
.meter {
  display: flex;
  gap: 6px;
}
.bar {
  flex: 1;
  height: 6px;
  background: #eee;
  border-radius: 3px;
  transition: background 0.2s ease;
}
.meter.level-weak .bar.active { background: #ff4d4f; }
.meter.level-medium .bar.active { background: #faad14; }
.meter.level-strong .bar.active { background: #fb6e01; }
.strength-text {
  font-size: 12px;
  margin-top: 4px;
  color: #666;
}
.strength-text.level-weak { color: #ff4d4f; }
.strength-text.level-medium { color: #faad14; }
.strength-text.level-strong { color: #fb6e01; }
</style>